import React from "react";
import HttpService from "../../utils/Http.services";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actions from "../../stores/actionsList";
import { checkTranslation, pathMaker, translate } from "../../utils/useful";
import WidgetComponents from "../../components/widgets/WidgetComponents";
import { withRouter } from "react-router";
import LoaderButton from "../../components/LoaderButton";
import Task from "../../components/widgets2/Task";
import UpdatesWidget from "../../components/widgets2/UpdatesWidget";
import Chart from "../../components/widgets2/Chart";
import ChartProgress from "../../components/widgets2/ProgressChart.jsx";
import Calendar from "../../components/widgets2/Calendar";
import Notes from "../../components/widgets2/Notes";
import Message from "../../components/widgets2/Message";
import StatusTask from "../../components/widgets2/StatusTask";
import TaskEmail from "../../components/widgets2/TaskEmail";
import ListView from "../../components/widgets2/ListView";
import ViewSwitcherWidget from "../../components/widgets2/ViewSwitcherWidget";
import WorkLoad from "../../components/widgets2/WorkLoad";
import WorkLoadHorizontal from "../../components/widgets2/WorkLoadHorizontal";
import WorkLoadChart from "../../components/widgets2/WorkLoadChart";

import ProductSection from "../../components/widgets2/ProductSection";
import CheckInCheckOut from "../../components/widgets2/CheckInCheckOut";
import SkeletonChart from "../../components/widgets2/SkletonChart";
import SkletonCart from "../../components/widgets2/SkletonCart";
import ProfileSkeleton from "../../components/widgets2/ProfileSkeleton";
import BarChartSkeleton from "../../components/widgets2/BarChartSkeleton";
import PieChartSkeleton from "../../components/widgets2/PieChartSkeleton";
import DashboardLink from "../../components/widgets2/DashboardLink";
import GaugeChart from "../../components/widgets2/GaugeChart";
import Responsive from "../../components/Responsive";
import LogsWidget from "../../components/widgets2/LogsWidget";

class TaskMainPage extends React.Component {
    state = {
        info: { modules: [] },
        data: [],
        // widgetsList: [
        //     1, 1, 1, 1, 1
        // ]
    };

    componentDidMount() {
        let id = this.props.data?.id ?? this.props.data?._id;

        if (id) {
            this.getDashboard(this.props.data);
            // this.getDashboard(id);
        } else {
            let info = this.state.info;
            info.name = "Dashboard Name";
            info.description = "Dashboard description can be shown here";
            info.modules = [];
            this.setState({ pageStatus: 200, info });
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.data != prevProps.data) {
            let id = this.props.data?.id ?? this.props.data?._id;
            if (id) {
                this.getDashboard(this.props.data);
                // this.getDashboard(id);
            } else {
                let info = this.state.info;
                info.name = "Dashboard Name";
                info.description = "Dashboard description can be shown here";
                info.modules = [];
                this.setState({ pageStatus: 200, info });
            }
        }

    }
    getDashboard = (data) => {
        let info = this.state.info;
        this.setState({ isLoading: true }, () => {
            info.modules = data.page;
            this.setState({ info, isLoading: false })
        });
    };

    // getDashboard = (id) => {
    //     this.setState({ isLoading: true });
    //     HttpService.request("getDashboard", { id }, (fetchResult, fetchError, fetchStatus) => {
    //         this.setState({ isLoading: false });
    //         this.setState({ pageStatus: fetchStatus });
    //         if (fetchError) {
    //             this.props.actions.addNotif({ type: "error", title: "{{lang}}errors.postDataFailed", description: fetchError.message, });
    //             return;
    //         }
    //         this.setState({ info: fetchResult.info });
    //     });
    // };

    removeConfirmed = () => {
        HttpService.request("removeDashboard", { id: this.state.info._id }, (fetchResult, fetchError, fetchStatus) => {
            this.setState({ isLoading: false });
            if (fetchError) {
                this.props.actions.addNotif({ type: "error", title: "{{lang}}errors.removeFailed", description: fetchError.message, });
                return;
            }
            this.props.history.push(pathMaker("/"));
            // this.setState({ info: fetchResult.info })
        }
        );
    };

    removeButton(info, action, showInMobile) {
        if (info?.isOwner) {
            return (
                <div className={"flexc " + (showInMobile ? "" : "d-none d-md-block")}>
                    <LoaderButton
                        onClick={() => action()}
                        isLoading={this.state.isLoadingRemove}
                        text={translate("Remove")}
                        type={"Oval"}
                        className=""
                        buttonStyle={{ outline: "none", backgroundColor: "#9ab", cursor: "pointer", padding: "5px 20px", borderRadius: 30, fontSize: 13, fontWeight: "bold", color: "#fff", border: "none", }}
                        width={30}
                        height={30}
                        color={"#202020"}
                    />
                    {/* <button className="" onClick={() => action()} style={{ backgroundColor: '#222530', color: '#fff', borderRadius: 40, padding: '5px 20px', fontWeight: 'bold' }}>SAVE</button> */}
                    {/* <button onClick={() => this.props.nextStage()} style={{ backgroundColor: '#202020', color: '#fff', borderRadius: 30, padding: '5px 15px', fontWeight: 'bold' }}>NEXT</button> */}
                </div>
            );
        }
    }

    sharingButton(info, action, showInMobile) {
        if (info?.isOwner) {
            return (
                <div className={"flexc " + (showInMobile ? "" : "d-none d-md-block")}>
                    <LoaderButton
                        onClick={() => action()}
                        isLoading={this.state.isLoadingSharing}
                        text={translate("Sharing")}
                        type={"Oval"}
                        className=""
                        buttonStyle={{ outline: "none", backgroundColor: "#9ab", cursor: "pointer", padding: "5px 20px", borderRadius: 30, fontSize: 13, fontWeight: "bold", color: "#fff", border: "none", }}
                        width={30}
                        height={30}
                        color={"#202020"}
                    />
                    {/* <button className="" onClick={() => action()} style={{ backgroundColor: '#222530', color: '#fff', borderRadius: 40, padding: '5px 20px', fontWeight: 'bold' }}>SAVE</button> */}
                    {/* <button onClick={() => this.props.nextStage()} style={{ backgroundColor: '#202020', color: '#fff', borderRadius: 30, padding: '5px 15px', fontWeight: 'bold' }}>NEXT</button> */}
                </div>
            );
        }
    }

    // editButton(info, action, showInMobile) {
    //     if (info?.isOwner) {
    //         return (
    //             <div className={"flexc mx-1 " + (showInMobile ? '' : 'd-none d-md-block')}>
    //                 <TLink className="" to={'/editDashboard/' + this.state.info._id} style={{ backgroundColor: '#222530', fontSize: 13, color: '#fff', borderRadius: 40, padding: '5px 20px', fontWeight: 'bold' }}>Edit</TLink>
    //             </div>
    //         )
    //     }
    // }

    openSharing = () => {
        this.searchUserModal.modal.showModal();
    };

    showModules = (item) => {
        return (
            item.children && item.children.map((prop) => {
                return (
                    prop.children && prop.children.map((cprop) => {
                        if (cprop?.information) {
                            let information = cprop.information
                            let Component = WidgetComponents[cprop.type];
                            if (Component) {
                                return (
                                    <div className={"col-12 col-md-4 col-lg-4 mb-4"} key={cprop._id ?? cprop.id}>
                                        {/* <div className={"mb-1 p-1  col-lg-" + (cprop.col ?? "4 ") + (" col-md-" + (cprop.col <= 6 ? "6 " : cprop.col)) + (" col-" + (cprop.col <= 3 ? "6 " : "12 "))} key={cprop._id ?? cprop.id}> */}
                                        {/* <div className="h-100 py-2 px-2 d-flex flex-column" style={{ backgroundColor: "#f5f5f5", borderRadius: 4 }}> */}
                                        <div className="dashboard-widgets" style={{}}>
                                            {/* <p className="text-center text-bold mt-2 mb-2 text-small">{checkTranslation(information.title)}</p> */}
                                            <Component data={cprop} dashboard={this.state.info} />
                                        </div>
                                    </div>
                                    // <WidgetContainer grid={prop.grid} id={prop.id} key={prop.id} data={prop} openMore={this.openMore} />
                                );
                            } else { }
                        }
                        else {
                            this.showModules(cprop)
                        }
                    })
                )
            })
        )
    }

    render() {
        return (
            <div className=" py-2 pt-4 px-2" style={{ height: "100%", overflow: 'auto', backgroundColor: '#f5f5f5' }}>
                <div className="flexcc mb-3 d-md-none ">
                    {/* {this.removeButton(this.openRemoveConfirmation, true)} */}
                    {/* {this.editButton(this.state.info, null, true)} */}
                </div>

                <div className="row m-0">
                    {/* <DraggableGrid dragstarted={this.dragStarted} dragover={this.dragOver} data={this.state.data} updatedata={this.updateData} width={400}> */}
                    {this.state.info?.modules && this.state.info?.modules.map((prop) => {
                        return (
                            this.showModules(prop)
                        )
                    })}



                    <Responsive className={' d-flex'} width={this.props.width} media={{ xs: "12", md: '6', lg: "4" }}>
                        <div className="p-2 w-100 mb-2">
                            <LogsWidget />
                        </div>
                    </Responsive>


                    <Responsive className={' d-flex'} width={this.props.width} media={{ xs: "12", md: '6', lg: "8" }}>
                        <div className="p-2 w-100 mb-2">
                            <ViewSwitcherWidget />
                        </div>
                    </Responsive>


                    <Responsive className={' d-flex'} width={this.props.width} media={{ xs: "12", md: '6', lg: "4" }}>
                        <div className="p-2 w-100 mb-2">
                            <WorkLoadHorizontal />
                        </div>
                    </Responsive>




                    <Responsive className={' d-flex'} width={this.props.width} media={{ xs: "12", md: '6', lg: "8" }}>
                        <div className="p-2 w-100 mb-2">
                            <Chart chartType={"bar"} />
                        </div>
                    </Responsive>




                    {/* <div className="col-12 col-md-6 col-lg-6 mb-4">
                        <ChartProgress
                            title={"Sales Transactions"}
                            modal={'singl'}
                        />
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 mb-4">
                        <ChartProgress
                            title={"Sales Transactions"}
                            modal={'test'}
                        />
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 mb-4">
                        <ChartProgress
                            title={"INVOICES"}
                            praise={'5.581.52'}
                            modal={'lop'}
                        />
                    </div> */}


                    <div className="col-12 col-md-6 col-lg-4 mb-4">
                        <Task />
                    </div>



                    <div className="col-12 col-md-6 col-lg-4 mb-4">
                        <ListView />
                    </div>

                    <div className="col-12 col-md-6 col-lg-4 mb-4">
                        <TaskEmail />
                    </div>


                    {/* <div className="col-12 col-md-4 col-lg-4 mb-4">
                        <CheckInCheckOut width={this.props.width} />
                    </div> */}

                    {/* <div className="col-12 col-md-6 col-lg-4 mb-4">
                        <MeetingsReady />
                    </div> */}

                    {/* <div className="col-12 col-md-6 col-lg-4 mb-4">
                            <Downloader />
                        </div> */}

                    {/* <div className="col-12 col-md-6 col-lg-4 mb-4">
                        <ImageComponent status={0} />
                    </div>

                    <div className="col-12 col-md-6 col-lg-4 mb-4">
                        <MessageComponent status={0} />
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 mb-4">
                        <VideoComponent status={0} progress={15} />
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 mb-4">
                        <GifComponent status={0} progress={15} />
                    </div>

                    <div className="col-12 col-md-6 col-lg-4 mb-4">
                        <AudioComponent status={0} />
                    </div>

                    <div className="col-12 col-md-6 col-lg-4 mb-4">
                        <FileComponent status={0} />
                    </div> */}

                    {/* <div className="col-12 col-md-6 col-lg-4 mb-4">
                            <Uploader />
                        </div> */}

                    {/* <div className="col-12 col-md-12 col-lg-12 mb-4">
                        <WorkLoadChart chartType={"line"} />
                    </div> */}



                    <div className="col-12 col-md-6 col-lg-8 mb-4">
                        <WorkLoad />
                    </div>

                    {/* <div className="col-12 col-md-6 col-lg-4 mb-4">
                        <Message />
                    </div> */}

                    <div className="col-12 col-md-6 col-lg-4 mb-4">
                        <Notes />
                    </div>

                    <div className="col-12 col-md-6 col-lg-8 mb-4">
                        <Calendar />
                    </div>

                    {/* <div className="col-12 col-md-6 col-lg-4 mb-4">
                        <ChartProgress
                            title={"Total Payables"}
                            subtitel={"Total Unpaid Bills"}
                        />
                    </div> */}

                    {/* <div className="col-12 col-md-6 col-lg-4 mb-4">
                        <ChartProgress
                            title={"Total Receivables"}
                            subtitel={"Total Unpaid Invoices"}
                        />
                    </div> */}

                    {/* <div className="col-12 col-md-12 col-lg-12 mb-4">
                        <Chart chartType={"Bar"} />
                    </div> */}
                    {/* <div className="col-12 col-md-6 col-lg-4 mb-4">
                        <IncomingVideoCall />
                    </div> */}

                    {/* <div className="col-12 col-md-6 col-lg-4 mb-4">
                        <IncomingVoiceCall />
                    </div> */}





                    {/* ************************** end anguti widget ******************  */}
                    {/* </DraggableGrid> */}
                </div>
            </div >
        );
    }
}

const mapStateToProps = (state) => ({
    settings: state.settings,
    user: state.user,
});
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(TaskMainPage));
